export default "__VITE_ASSET__C7Ic$RmS__"